export default __webpack_public_path__ + "static/media/camera.1a8f7ab4.svg";